document.addEventListener('DOMContentLoaded', function() {

  const intro = document.querySelector('.section-introduction');
  if (intro) intro.style.setProperty('text-align', 'center', 'important');

  const recHeading = document.querySelector('.recommended-products__heading');
  if (recHeading) recHeading.style.setProperty('text-align', 'center', 'important');

  (function () {
    var patched = false;

    function patchCarouselImages() {
      var images = document.querySelectorAll('.Vtl-ReviewsCarousel__Image');
      if (!images.length) return false;
      images.forEach(function (img, index) {
        if (index === 0) return;
        if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
        if (!img.hasAttribute('fetchpriority')) img.setAttribute('fetchpriority', 'low');
        if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
      });
      return true;
    }

    if (patchCarouselImages()) { patched = true; }

    if (!patched) {
      var observer = new MutationObserver(function () {
        if (patchCarouselImages()) {
          patched = true;
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { if (!patched) observer.disconnect(); }, 20000);
    }
  })();
});

function fixChatPosition() {
  if (window.innerWidth <= 768) {
    var chat = document.querySelector('.Vtl-LiveChatChannelsWidget--Full');
    if (chat) {
      chat.style.setProperty('bottom', '90px', 'important');
    }
  }
}
document.addEventListener('DOMContentLoaded', fixChatPosition);
window.addEventListener('resize', fixChatPosition);
setTimeout(fixChatPosition, 2000);